<template>
	<div class="contract">
		<Header />
		<TopSection heading="Add Contract" subheading="Accenture - ACC0002" user="J K" />
        <v-dialog v-model="success" max-width="522px">
            <div class="notification-heading standard-height blue pr-4">
                <v-icon @click="contractsRedirect" class="white body-2 blue--text notification-close mr-1">close</v-icon>
            </div>
            <div class="notification-content white">
                <span class="primary--text font-weight-bold">Contract successfully created</span>
            </div>
        </v-dialog>
        <v-form ref="form" lazy-validation>
            <v-container class="pt-3" grid-list-lg>
                <v-layout row wrap>
                    <v-flex xs12 sm4 xl2 >
                            <v-select
                            height=66
                            background-color="blue"
                            color="primary"
                            :items="items"
                            label="Licence Type"
                            append-icon="keyboard_arrow_down"
                            solo></v-select>
                    </v-flex>
                    <v-flex xs12 sm8 xl10 class="form-section">
                        <div class="standard-height blue py-4 px-4 cc__box-shadow relative">
                            <span class="pl-3 white--text subheading font-weight-bold">Description</span>
                        </div>
                        <v-textarea
                            flat
                            solo
                            rows=9
                            no-resize
                            placeholder="Descriptive text detailing who the licences are for"
                            class="mb-1">
                        </v-textarea>
                    </v-flex>

                </v-layout>

                <v-layout row wrap>
                    <v-flex xs12 md4 xl2 class="mb-2">
                        <div class="standard-height blue py-4 px-4 relative">
                            <span class="pl-3 white--text subheading font-weight-bold">Number of Licences</span>
                        </div>
                        <div class="standard-height white relative pl-4">
                            <vue-numeric-input :value="50" controls-type="updown"></vue-numeric-input>
                        </div>
                    </v-flex>
                    <v-flex xs12 sm6 md4 xl2 class="mb-2">
                        <div class="standard-height blue py-4 px-4 relative">
                            <span class="pl-3 white--text subheading font-weight-bold">Valid From</span>
                        </div>
                        <div class="standard-height white relative pl-4 date-picker__from">
                            <span :v-model="fromPicker" class="primary--text pl-3 standard-lh">{{ fromPicker }}</span>
                            <button class="cc__box-shadow square-button pull-right" @click="showCalendar('from')">
                                <v-icon color="black">date_range</v-icon>
                            </button>
                            <div :class="`${show.from ? '' : 'hide'}`">
                                <v-date-picker scrollable @input="show.from = !show.from" header-color="blue" full-width v-model="fromPicker"></v-date-picker>
                            </div>
                        </div>
                    </v-flex>
                    <v-flex xs12 sm6 md4 xl2 class="mb-2">
                        <div class="standard-height blue py-4 px-4 relative">
                            <span class="pl-3 white--text subheading font-weight-bold">Valid To</span>
                        </div>
                        <div class="standard-height white relative pl-4">
                            <span :v-model="toPicker" class="primary--text pl-3 standard-lh">{{ toPicker }}</span>
                            <button class="cc__box-shadow square-button pull-right" @click="showCalendar('to')">
                                <v-icon color="black">date_range</v-icon>
                            </button>
                            <div :class="`${show.to ? '' : 'hide'}`">
                                <v-date-picker scrollable @input="show.to = !show.to" header-color="blue" full-width v-model="toPicker"></v-date-picker>
                            </div>
                        </div>
                    </v-flex>
                </v-layout>
                <v-layout row wrap class="mt-5 pt-1">
                    <v-flex xs12 sm6 md4 xl2>
                        <v-btn @click="success = true" block large color="grey lighten-1" class="mt-3 pl-4 pr-3 text-icon-button ml-0">
                            <span class="pl-3 white--text subheading text-capitalize font-weight-bold pl-3">Create Contract</span>
                            <v-icon right class="white--text title">add</v-icon>
                        </v-btn>
                    </v-flex>
                    <v-flex xs12 sm6 md4 xl2>
                        <v-btn href="/contracts" block large color="grey lighten-1" class="mt-3 pl-4 pr-3 text-icon-button ml-0">
                            <span class="pl-3 white--text subheading text-capitalize font-weight-bold pl-3">Cancel</span>
                        </v-btn>
                    </v-flex>
                </v-layout> 
            </v-container>
        </v-form>
	</div>
</template>

<script>
    let show = {
        from: false,
        to: false
    }
	import TopSection from '../components/TopSection.vue'
    import Header from '../components/Header.vue'
    import router from '../router'
    import VueNumericInput from 'vue-numeric-input';
	export default {
		name: 'App',
		components: {
            Header, TopSection,
            'vue-numeric-input': VueNumericInput
        },
        data() {
            return {
                fromPicker: new Date().toISOString().substr(0, 10),
                toPicker: new Date().toISOString().substr(0, 10),
                items: ['Centre', 'Individual', 'Guest'],
                show,
                success: false
            }
        },
        methods: {
            showCalendar(type) {
                event.preventDefault()
                this.show[type] = true
            },
            contractsRedirect() {
                router.push('/contracts')
            }
        }
	}

</script>
